import React, { Component } from 'react'

import { connect } from 'react-redux'
import { CircularProgress } from 'material-ui/Progress'

import Job from './Job'
import ExportContainer from './ExportContainer'
import PaginatorContainer from './PaginatorContainer'

import { fetchJobs, resetInMemoryJob, clearSuccessMessage } from './jobs-reducer'

import JobListMenuBar from './JobListMenuBar'

class JobsContainer extends Component {
  shouldComponentUpdate (nextProps) {
    const {
      jobs,
      pages,
      currentPage
    } = nextProps

    const page = pages[currentPage] || {}
    return jobs.length >= page.end
  }

  render () {
    const {
      jobs,
      pages,
      currentPage,
      history,
      resetInMemoryJob,
      clearSuccessMessage,
      isJobsRequestOngoing
    } = this.props

    const handleNewJob = () => {
      // reset form here
      resetInMemoryJob()
      clearSuccessMessage()

      // now move to job creation form
      history.push('jobs/form')
    }

    if (isJobsRequestOngoing) {
      return (<div>
        <JobListMenuBar handleNewJob={handleNewJob} />
        <CircularProgress />
      </div>)
    }

    const page = pages[currentPage] || []
    const nextJobs = jobs.slice(page.start, page.end)
    const handleAssign = (jobId) => {
      clearSuccessMessage()
      history.push(`job/${encodeURIComponent(jobId)}/assign-driver`)
    }

    const openManifest = (jobId, stopId) => {
      clearSuccessMessage()
      history.push(`/manifest/${encodeURIComponent(jobId)}/${encodeURIComponent(stopId)}`)
    }

    return (
      <div>
        <JobListMenuBar handleNewJob={handleNewJob} />
        {nextJobs.map(job => <Job
          {...job}
          key={job.job._id}
          handleAssign={handleAssign}
          openManifest={openManifest}
        />)}
        <ExportContainer />
        <PaginatorContainer />
      </div>
    )
  }
}

const mapStateToProps = ({
  jobs: { jobs, stockBalance, isJobsRequestOngoing },
  pagination: { pages, currentPage }
}) => ({ jobs, pages, currentPage, stockBalance, isJobsRequestOngoing })

export default connect(mapStateToProps, { fetchJobs, clearSuccessMessage, resetInMemoryJob })(JobsContainer)



// WEBPACK FOOTER //
// ./src/jobs/JobsContainer.js